import { render, staticRenderFns } from "./BlogTopBackground.vue?vue&type=template&id=13577066&scoped=true&"
import script from "./BlogTopBackground.vue?vue&type=script&lang=js&"
export * from "./BlogTopBackground.vue?vue&type=script&lang=js&"
import style0 from "./BlogTopBackground.vue?vue&type=style&index=0&id=13577066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13577066",
  null
  
)

export default component.exports